import React from 'react';

import '../style.css';

export default function RightChevronIcon({ fill = '#64C2E6' }) {
  return (
    <svg
      viewBox='0 0 32 32'
      style={{
        display: 'block',
        marginRight: 'auto',
      }}>
      <defs>
        <clipPath id='c0_1'>
          <path d='M11.8,25.5l-2,-1.9l8.5,-8.1L9.8,7.5l2,-1.9l10.5,9.9l-10.5,10Z' />
        </clipPath>
      </defs>
      <g clipPath='url(#c0_1)'>
        <path d='M6,29.3H26.1V1.8H6V29.3Z' fill={fill} />
      </g>
    </svg>
  );
}
